import { render } from "./Setting_Left.vue?vue&type=template&id=f9210db0"
import script from "./Setting_Left.vue?vue&type=script&lang=js"
export * from "./Setting_Left.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__